export default __webpack_public_path__ + "static/media/available_hover_connected.a4122c3c.svg";